import React from 'react'

const DebugContext = React.createContext({})

export default DebugContext
